import AdministrationAddEligibilityMessagePriorityPopup from './AdministrationAddEligibilityMessagePriorityPopup';
import AdministrationEditEligibilityMessagePriorityPopup from './AdministrationEditEligibilityMessagePriorityPopup';

export {
    AdministrationAddEligibilityMessagePriorityPopup,
    AdministrationEditEligibilityMessagePriorityPopup,
}